export default __webpack_public_path__ + "static/media/ic_warning.ad0ae84c.svg";